/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiTagFromJSON, StreemApiTagToJSON, } from './';
export function StreemApiGetCompanyTagResponseFromJSON(json) {
    return StreemApiGetCompanyTagResponseFromJSONTyped(json, false);
}
export function StreemApiGetCompanyTagResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'tag': !exists(json, 'tag') ? undefined : StreemApiTagFromJSON(json['tag']),
    };
}
export function StreemApiGetCompanyTagResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'tag': StreemApiTagToJSON(value.tag),
    };
}
//# sourceMappingURL=StreemApiGetCompanyTagResponse.js.map